import React, { useState } from "react";
import {
  AppstoreOutlined,
  FolderOpenOutlined,
  LogoutOutlined,
  MenuOutlined,
  PlusCircleOutlined,
  SafetyCertificateOutlined,
  UserAddOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import adminApi from "../api/adminApi";

const navigation = [
  { to: "/admin", label: "Overview", icon: <AppstoreOutlined />, end: true },
  { to: "/admin/projects", label: "Projects", icon: <FolderOpenOutlined /> },
  { to: "/admin/categories", label: "Categories", icon: <TagsOutlined /> },
  { to: "/admin/security", label: "Security", icon: <SafetyCertificateOutlined /> },
  { to: "/admin/users/new", label: "Add user", icon: <UserAddOutlined /> },
];

const titles = {
  "/admin": ["Overview", "Monitor and manage your solar portfolio"],
  "/admin/projects": ["Projects", "Manage installations and project media"],
  "/admin/projects/new": ["Create project", "Add a completed solar installation"],
  "/admin/categories": ["Categories", "Organize projects by installation type"],
  "/admin/security": ["Security", "Manage your administrator password"],
  "/admin/users/new": ["Add administrator", "Create secure access for another user"],
};

export default function AdminLayout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isEdit = location.pathname.endsWith("/edit");
  const [title, subtitle] = isEdit
    ? ["Edit project", "Update installation details and media"]
    : titles[location.pathname] || ["Admin", "Sun Pledge management console"];
  const showNewProject = !["/admin/security", "/admin/users/new"].includes(location.pathname);

  function logout() {
    adminApi.logout();
    navigate("/admin/login", { replace: true });
  }

  return (
    <div className="admin-shell">
      {open && <button className="admin-backdrop" onClick={() => setOpen(false)} aria-label="Close menu" />}
      <aside className={`admin-sidebar ${open ? "is-open" : ""}`}>
        <div className="admin-brand">
          <img src="/images/CompanyLogo.png" alt="Sun Pledge" />
          <div><strong>Sun Pledge</strong><span>Admin console</span></div>
        </div>
        <nav className="admin-nav">
          <span className="admin-nav-label">Workspace</span>
          {navigation.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) => `admin-nav-item ${isActive ? "active" : ""}`}
            >
              {item.icon}<span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <div className="admin-profile"><span>SP</span><div><strong>Administrator</strong><small>System access</small></div></div>
          <button onClick={logout} className="admin-logout"><LogoutOutlined /> Sign out</button>
        </div>
      </aside>
      <main className="admin-main">
        <header className="admin-topbar">
          <button className="admin-menu" onClick={() => setOpen(true)} aria-label="Open menu"><MenuOutlined /></button>
          <div><h1>{title}</h1><p>{subtitle}</p></div>
          {showNewProject && <NavLink to="/admin/projects/new" className="admin-primary-button admin-top-action"><PlusCircleOutlined /> New project</NavLink>}
        </header>
        <div className="admin-content"><Outlet /></div>
      </main>
    </div>
  );
}
